import { useQuery } from 'react-query';
import { findActiveBanners } from '../utils/api/bannerApi';
var useAdsBannerForPage = function (page) {
    var _a = useQuery(
    // Cache data by banner and what page we request
    ['banner', page], function () { return findActiveBanners(page); }, {
        staleTime: 3600000, // 60 minutes should be sufficient
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error;
    return {
        isLoading: isLoading,
        banners: data || {},
        error: error || undefined,
    };
};
export default useAdsBannerForPage;
